import { render, staticRenderFns } from "./tvs_staff.vue?vue&type=template&id=420a17e2&scoped=true"
import script from "./tvs_staff.vue?vue&type=script&lang=js"
export * from "./tvs_staff.vue?vue&type=script&lang=js"
import style0 from "./tvs_staff.vue?vue&type=style&index=0&id=420a17e2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420a17e2",
  null
  
)

export default component.exports